<template>
  <div class="expense-details">
    <section class="details-section">
      <ExpenseDetailsBody :expense="currentExpense" />
    </section>
  </div>
</template>

<script>
import ExpenseDetailsBody from './components/ExpenseDetailsBody';

import { ExpenseDetailsActions } from './expense-details.keys';
import { AppActions } from '@/app/app.keys';

export default {
  name: 'ExpenseDetails',
  components: {
    ExpenseDetailsBody
  },
  computed: {
    currentExpense() {
      return this.$store.state.expensesState.expenseDetailsState.currentExpense;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.$store.dispatch(ExpenseDetailsActions.RetrieveExpense, val.params.id);
      }
    }
  },
  destroyed() {
    this.$store.dispatch(ExpenseDetailsActions.ResetCurrentExpense);
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('expenses.details.expense'));
    this.$store.dispatch(ExpenseDetailsActions.RetrieveExpense, this.$route.params.id);
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../styles/colors.scss';
@import '../../../../styles/variables.scss';

@media print {
  .expense-details .details-section {
    margin: 0;
  }
}
</style>
